import XLSX from 'xlsx-js-style';
import { buildSheet, fileStamp, ColType } from '../../../src/lib/excelExport';
import { ColunaPlanilhaRateio, Rateio, RateioItem, RateioUnidadeGeradora } from '../../../types';

// Colunas disponíveis pra planilha de protocolo — o CONJUNTO é configurável
// por distribuidora (distribuidora_config.colunas_planilha, Fatia 8), mas a
// ORDEM segue sempre esta ordem canônica (evita a complexidade de permitir
// reordenação por distribuidora). Layout exato por concessionária continua
// uma lacuna não resolvida — isso aqui só torna o conjunto configurável em
// vez de fixo, ver docs/PLAN-modulo-rateio.md Seção 6.
const COLUNA_DEFS: Record<ColunaPlanilhaRateio, { header: string; tipo: ColType; valor: (item: RateioItem) => string | number }> = {
  uc: { header: 'UC', tipo: 'txt', valor: item => item.uc },
  outro_numero_uc: { header: 'Outro Nº UC', tipo: 'txt', valor: item => item.outro_numero_uc || '' },
  titular: { header: 'Titular', tipo: 'txt', valor: item => item.nome || '' },
  cpf_cnpj: { header: 'CPF/CNPJ', tipo: 'txt', valor: item => item.cpf_cnpj || '' },
  percent: { header: '% do Excedente', tipo: 'pct', valor: item => item.percent_rateio },
  energia_alvo_kwh: { header: 'Energia-Alvo (kWh)', tipo: 'kwh', valor: item => item.energia_alvo_kwh },
};

const COLUNAS_DEFAULT: ColunaPlanilhaRateio[] = ['uc', 'titular', 'cpf_cnpj', 'percent'];

export function gerarPlanilhaRateioWorkbook(itens: RateioItem[], colunas: ColunaPlanilhaRateio[] = COLUNAS_DEFAULT): XLSX.WorkBook {
  const ordemCanonica = (Object.keys(COLUNA_DEFS) as ColunaPlanilhaRateio[]).filter(c => colunas.includes(c));
  const defs = (ordemCanonica.length > 0 ? ordemCanonica : COLUNAS_DEFAULT).map(c => COLUNA_DEFS[c]);
  const headers = defs.map(d => d.header);
  const tipos = defs.map(d => d.tipo);
  const rows = itens.map(item => defs.map(d => d.valor(item)));
  const ws = buildSheet(headers, rows, tipos);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Rateio');
  return wb;
}

export function nomeArquivoPlanilha(ug: RateioUnidadeGeradora, rateio: Rateio): string {
  const mes = rateio.mes_referencia.replace(/[\/\s]/g, '-');
  const nomeUg = ug.nome.replace(/[^\w-]+/g, '_');
  return `Rateio_${nomeUg}_${mes}_${fileStamp()}.xlsx`;
}

/** Baixa a planilha diretamente no navegador (usado quando não há webhook configurado). */
export function baixarPlanilhaRateio(
  ug: RateioUnidadeGeradora,
  rateio: Rateio,
  itens: RateioItem[],
  colunas?: ColunaPlanilhaRateio[]
): void {
  const wb = gerarPlanilhaRateioWorkbook(itens, colunas);
  XLSX.writeFile(wb, nomeArquivoPlanilha(ug, rateio));
}

/** Gera o arquivo como Blob (usado para upload no Storage antes do webhook). */
export function gerarPlanilhaRateioBlob(itens: RateioItem[], colunas?: ColunaPlanilhaRateio[]): Blob {
  const wb = gerarPlanilhaRateioWorkbook(itens, colunas);
  const buffer = XLSX.write(wb, { type: 'array', bookType: 'xlsx' }) as ArrayBuffer;
  return new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
}
